// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"472":"26377b75","573":"44dd8f6e","897":"1c73c83e"}[chunkId] + ".css";
};